// extracted by mini-css-extract-plugin
export default {"link":"nIN4Nl","root":"W2Izjj","label":"Ai6ry5","justx":"HHI6nu","circle":"MBG2yQ"};